import { Component, OnInit } from "@angular/core";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { Router } from "@angular/router";
import * as toastr from 'toastr'

import { State } from "@shared/models/state.interface";
import { City } from "@shared/models/city.interface";
import { ClientesService } from "../../services/clientes.service";
import { VendasService } from "../../services/vendas.service";
import { Utilservice } from "@core/services/util.service";
import { LocationsService } from '../../services/locations.service';
import * as _ from 'lodash'

@Component({
  selector: "app-visao-cidade",
  templateUrl: "./visao-cidade.component.html",
  styleUrls: ["./visao-cidade.component.css"]
})
export class VisaoCidadeComponent implements OnInit {
  faPlus = faPlus;
  faMinus = faMinus;
  lsStates: State[] = [];
  lsCities: City[] = [];
  lsDistricts: String[] = [];
  lsSetores: any[] = [];
  lsLinhas: any[] = [];
  lsComercio: any[] = [];
  lsComercioNotSelected: any[] = [];
  lsMeses: any[];
  lsSelectedLinha: any[] = [];
  lsSelectedComercio: any[] = [];
  lsClients: {
    data:any[],
    total:any
  };
  isConsulta: Boolean = false;
  isRequesting: Boolean = false;
  isSearchingByCity = false;
  isSearchingByDistrict = false;
  serverDate:Date;
  anoAtual:string;
  anosConsulta:string[] = [];

  selectedVendedor: string;

  parameters: any;

  id = 1;

  setorFzs;
  setorCdFzs;
  userLogado;
  private debouncedGetSetor =  _.debounce(()=>this.getIdSetorComc(), 1000, {
    'leading': false,
    'trailing': true
  })

  constructor(
    private clientService: ClientesService,
    private vendaService: VendasService,
    private locationService: LocationsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));
    this.setorCdFzs = this.userLogado.perfil != 3 ? this.userLogado.setor : null
    this.parameters = {
      mesInicial: "",
      mesFinal: "",
      uf: "",
      cidade: "",
      bairro:"",
      setor: this.userLogado.perfil != 3 ? this.userLogado.idSetor : null,
      diasSemMovimento: "",
      linha: "",
      comercio: ""
    };

    if(this.userLogado.perfil !== 3){
      //this.getStates(this.userLogado.setor);
      this.setorFzs = this.userLogado.setor
    }

    this.getPeriodo()
    this.getLinhas();
    this.getComercios();
    if(this.userLogado.perfil !== 3){
      this.getStates(this.parameters.setor);
    }
    this.getSetores();

    //se for perfil vendedor
    this.userLogado.perfil == 1
      ? (this.selectedVendedor = this.userLogado.id)
      : "";

    this.lsMeses = this.vendaService.getMeses();


  }

  getPeriodo(){
    this.clientService.getPeriodoVisaoCidade().subscribe(
      data => {
        this.anoAtual = data[0].ano;
        const anosConsulta = []
        //
        for(let i=0; i<= Math.abs(parseInt(data[0].periodo) ); i++){
          anosConsulta.unshift(data[0].ano-i)
        }

        this.anosConsulta = anosConsulta;
        console.log('asas', data[0])
      },
      error => {
        console.log(error)
      }
    )

  }

  getLinhas() {
    this.clientService.getLinhas().subscribe(
      data => {
        this.lsLinhas = data;

        const parameters = this.parameters;

        data.forEach(element => {
          if (element.descricao === "LINHA DIA") {
            parameters.linha = element.id;
          }
        });

        this.parameters = parameters;
      },
      error => console.log(error)
    );
  }

  getComercios() {
    this.clientService.getComercios().subscribe(
      data => {
        data.forEach((element, index) => {
          data[index].index = index;
        });
        this.lsComercio = data;
        this.lsComercioNotSelected = data;
      },
      error => console.log(error)
    );
  }

  getStates(id) {
      this.clientService
        .getStates(id)
        .subscribe(data => (this.lsStates = data), error => console.log(error));
  }

  getSetores() {
    this.clientService
      .getSetores()
      .subscribe(
        data => (this.lsSetores = data),
        error => console.log(error),
        () => console.log("States Loaded")
      );
  }

  filterCities(filterVal: any) {
    if (filterVal === "undefined") return;

    this.lsDistricts = [];

    this.clientService
      .getCities(this.parameters.uf, this.userLogado.idSetor)
      .subscribe(
        data => {
          this.lsCities = data;
        },
        error => console.log(error)
      );
  }

  filterDistricts(filterVal: any) {
    if (filterVal === "undefined") return;

    this.clientService
      .getDistricts(this.parameters.cidade, this.userLogado.idSetor)
      .subscribe(
        data => {
          this.lsDistricts = data;
        },
        error => console.log(error)
      );
  }

  onDeleteLinha(linha) {
    let lsSelectedLinha = this.lsSelectedLinha;
    const lsLinhas = this.lsLinhas;

    lsSelectedLinha = lsSelectedLinha.filter(value => value.id != linha.id);

    lsLinhas.push(linha);

    lsLinhas.sort(function(a, b) {
      return a.index - b.index;
    });

    this.lsLinhas = lsLinhas;

    this.lsSelectedLinha = lsSelectedLinha;
  }

  onAddComercio() {
    const selectedComercio = this.parameters.comercio;
    const lsSelectedComercio = this.lsSelectedComercio;
    const lsComercioNotSelected = this.lsComercioNotSelected;

    lsComercioNotSelected.forEach(comercio => {
      if (comercio.id === selectedComercio) {
        lsSelectedComercio.push(comercio);
      }
    });

    this.lsComercioNotSelected = lsComercioNotSelected.filter(value => value.id !== selectedComercio);

    this.lsSelectedComercio = lsSelectedComercio;

    this.parameters.comercio = "";
  }

  onDeleteComercio(comercio) {
    let lsSelectedComercio = this.lsSelectedComercio;

    const lsComercioNotSelected = this.lsComercioNotSelected;

    lsSelectedComercio = lsSelectedComercio.filter(
      value => value.id != comercio.id
    );

    lsComercioNotSelected.push(comercio);

    lsComercioNotSelected.sort(function(a, b) {
      return a.index - b.index;
    });

    this.lsComercioNotSelected = lsComercioNotSelected;

    this.lsSelectedComercio = lsSelectedComercio;
  }

  reset() {
    this.parameters = {
      mesInicial: "",
      mesFinal: "",
      uf: "",
      cidade: "",
      setor: this.userLogado.idSetor,
      diasSemMovimento: "",
      linha: 2,
      comercio: "",

    };

    this.lsComercioNotSelected = this.lsComercio
    this.lsSelectedLinha = [];
    this.lsSelectedComercio = [];
  }

  onConsultar() {


    const parameters = {
      mesInicial: this.parameters.mesInicial,
      mesFinal: this.parameters.mesFinal,
      uf: this.parameters.uf,
      cidade: this.parameters.cidade,
      setor: this.parameters.setor,
      diasSemMovimento: this.parameters.diasSemMovimento,
      linhas: this.parameters.linha,
      listTipoComercio: this.lsSelectedComercio,
      bairro:this.parameters.bairro
    };

    if(+parameters.mesInicial > +parameters.mesFinal){
      toastr.error('Campo "Vendas do Mês" deve ser menor ou igual ao campo "Até o Mês"')
      return;
    }

    this.isConsulta = !this.isConsulta;
    this.isRequesting = true;

    Object.keys(parameters).forEach(key => {
      if (parameters[key] === null || (parameters[key] && parameters[key].length === 0)) {
        delete parameters[key];
      }
    });

    this.isSearchingByCity = parameters.cidade ? true :false
    this.isSearchingByDistrict = parameters.bairro ? true :false

    const anoAtual = this.anoAtual;

    this.clientService
      .getVisaoCidade(parameters)
      .finally(() => (this.isRequesting = false))
      .subscribe(
        data => {
          const dataClientList:any = data
          let clientListObject = {};

          const total:any = {}

          this.anosConsulta.map( ano => {
            total[ano] = {
              faturamento:0,
              venda:0,
              diferencaFaturamentoComAnoAtual:0,
              diferencaVendaComAnoAtual:0
            }
          })

          if(parameters.cidade){
            dataClientList.map(item => {
              if(!clientListObject[item.razaoSocial]){
                clientListObject[item.razaoSocial] = {
                  razaoSocial:item.razaoSocial,
                  cnpj:item.cnpj,
                  tipoComercio:item.tipoComercio,
                  data:{}
                };
              }

              if(!clientListObject[item.razaoSocial].data[item.ano.toString()]){
                clientListObject[item.razaoSocial].data[item.ano.toString()] = {
                  faturamento:0,
                  venda:0
                }
              }

              clientListObject[item.razaoSocial].data[item.ano.toString()].faturamento += item.qtPecasFat;
              clientListObject[item.razaoSocial].data[item.ano.toString()].venda += item.qtPecasPed;
            })
          }else{
            dataClientList.map(item => {
              if(!clientListObject[item.municipio]){
                clientListObject[item.municipio] = {
                  cidade:item.municipio,
                  data:{}
                };
              }

              if(!clientListObject[item.municipio].data[item.ano.toString()]){
                clientListObject[item.municipio].data[item.ano.toString()] = {
                  faturamento:0,
                  venda:0
                }
              }

              clientListObject[item.municipio].data[item.ano.toString()].faturamento += item.qtPecasFat;
              clientListObject[item.municipio].data[item.ano.toString()].venda += item.qtPecasPed;
            })
          }

          const clientList = Object.values(clientListObject);

          clientList.map( item => {
            Object.keys(item['data']).map( ano => {
              if(!item['data'][anoAtual]){
                item['data'][anoAtual] = {
                  faturamento:0,
                  venda:0
                }
              }

              if(ano == anoAtual){
                total[ano].faturamento += item['data'][ano].faturamento
                total[ano].venda += item['data'][ano].venda
              }else{
                item['data'][ano].diferencaFaturamentoComAnoAtual = item['data'][anoAtual].faturamento - item['data'][ano].faturamento
                item['data'][ano].diferencaVendaComAnoAtual = item['data'][anoAtual].venda - item['data'][ano].venda

                total[ano].faturamento += item['data'][ano].faturamento
                total[ano].venda += item['data'][ano].venda
                total[ano].diferencaFaturamentoComAnoAtual += item['data'][ano].diferencaFaturamentoComAnoAtual
                total[ano].diferencaVendaComAnoAtual += item['data'][ano].diferencaVendaComAnoAtual
              }
            })
          })

          return this.lsClients = {
            data:clientList,
            total
          };;
        },
        error => console.log(error)
      );
  }

  onBack() {
    this.router.navigate(["/clientes/home/"]);
  }

  getVisaoUF() {
    const selectedUf = this.parameters.uf;

    let uf = this.lsStates.find(value => value.idUf === selectedUf);

    return uf.sgUf;
  }

  getVisaoCidade() {
    const selectedCidade = this.parameters.cidade;

    let cidade = this.lsCities.find(value => value.idMunic === selectedCidade);

    return cidade.nmMunic;
  }

  getVisaoSetor() {
    const selectedSetor = this.parameters.setor;

    let setor = this.lsSetores.find(value => value.id === selectedSetor);

    return setor.codigo;
  }

  getInicio() {
    const selectedMesInicial = this.parameters.mesInicial;

    let data = this.vendaService
      .getMeses()
      .find(value => value.id === selectedMesInicial);

    return data.name;
  }

  getFim() {
    const selectedMesFinal = this.parameters.mesFinal;

    let data = this.vendaService
      .getMeses()
      .find(value => value.id === selectedMesFinal);

    return data.name;
  }

  formatCnpj(v) {
    return Utilservice.formatCnpj(v);
  }

  formatCep(cep) {
    return Utilservice.formatCep(cep);
  }

  getVenda(cliente, ano) {
    let quantidade = 0;

    const vendas = cliente.vendaPorAno;

    if (vendas.find(value => value.mes === ano)) {
      quantidade = vendas.find(value => value.mes === ano).quantidade;
    }

    return quantidade;
  }

  getFaturamento(cliente, ano) {
    let quantidade = 0;

    const faturamentos = cliente.faturamentoPorAno;

    if (faturamentos.find(value => value.mes === ano)) {
      quantidade = faturamentos.find(value => value.mes === ano).quantidade;
    }

    return quantidade;
  }

  getDiferencaVenda(cliente, ano) {
    let quantidade = 0;

    const diferenca = cliente.diferencaVenda;

    if (diferenca.find(value => value.mes === ano)) {
      quantidade = diferenca.find(value => value.mes === ano).quantidade;
    }

    return quantidade;
  }

  getDiferencaFaturamento(cliente, ano) {
    let quantidade = 0;

    const diferenca = cliente.diferencaFaturamento;

    if (diferenca.find(value => value.mes === ano)) {
      quantidade = diferenca.find(value => value.mes === ano).quantidade;
    }

    return quantidade;
  }

  onCancel() {
    this.isRequesting = false;
    this.isConsulta = false;

    this.reset();
  }

  blockAllButPositiveNumbers(event){
    if (
      (event.keyCode < 48 || event.keyCode > 57) &&
      (event.keyCode < 96 || event.keyCode > 105) &&
      event.keyCode != 8 &&
      event.keyCode != 13 &&
      event.keyCode != 46 &&
      event.keyCode != 37 &&
      event.keyCode != 39
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  /*getMonthFormatted(monthNumber:string, lastDay?:boolean){
    if(lastDay){
      const year = moment(monthNumber, 'MM').endOf('month').format('DD-MM-YYYY');

      return year;
    }else{
      const year = moment(monthNumber, 'MM').startOf('month').format('DD-MM-YYYY');

      return year;
    }
  }*/

  getIdSetorComc(){
    this.clientService.getIdSetor(this.parameters.setor)
      .subscribe(
        data => {
          const idSetor: any = data;
          if(idSetor != 0){
            //this.parameters.setor = data
            this.getStates(data)
          }else{
            toastr.error('Setor não encontrado')
          }

        },
        error => {
          console.log(error)
        }
      )
  }

  onSetorChange(event){
    this.debouncedGetSetor()
  }
}
